module.exports = __webpack_public_path__ + "img/logo ljrs.35ee3a01.png";